import { useAuthContext } from "@app/authContext";
import { BgAgentMasterStartForm, startProcess } from "@services/api";
import { BgFormType } from "@services/guarantees/types";
import { message } from "antd";
import { useState } from "react";

export const useSaveOrder = () => {
  const { auth } = useAuthContext();
  const access_token = auth?.access_token ?? "";

  const [saving, setSaving] = useState<boolean>(false);

  const handleSave = async (data: BgFormType) => {
    try {
      //BgFormType и BgAgentMasterStartForm - по сути зеркальные типы. Возможно нужна маппинг утилита чтобы уйти от каста типов
      const orderId = await startProcess('carrot-cpa-bg-agent', data as BgAgentMasterStartForm, access_token);
      console.log('Создана заявка с orderId:', orderId);
      return orderId;
    } catch (err: any) {
      console.error(err);
      message.error(`Ошибка при создании заявки: ${err?.message || err}`);
    } finally {
      setSaving(false);
    }
  };

  return {
    saving,
    handleSave
  }
}
